import { Button, Container, Divider, Grid, Segment } from "semantic-ui-react";
import IkonParaply from "../images/Rain-Umbrella.png";
import IkonStack from "../images/IkonStack.svg";
import IkonTag from "../images/IkonTag.svg";
import "./Selvstaendige.css";
import HeaderImage from "./common/HeaderImage";
import Forsidebillede from "../images/pensionsdagen2026.jpg";
import AutoAccordion from "./common/AutoAccordion";

const Pensionsdagen = (props) => (
  <div style={{ backgroundColor: "white" }}>
    <HeaderImage imageSrc={Forsidebillede} />
    <Container text>
      <Segment basic>
        <p>Oktober 2026</p>
        <h2 className="ui header" style={{ paddingTop: 0 }}>
          Hvad skal din pension kunne for dig?
        </h2>
      </Segment>
    </Container>

    <Container text>
      <Segment basic>
        <p className="manchet">
          Den 25. oktober får du en time foræret, når sommertiden slutter. Brug
          10 minutter af den på at tænke over, hvad du gerne vil have ud af de
          mange år, der venter – og om din pension passer til det.
        </p>

        <p>
          Pension handler nemlig ikke bare om et stort tal på en konto. Det
          handler om, hvornår du kan stoppe med at arbejde, hvordan du kan leve
          – og hvor godt du og din familie er sikret, hvis livet ændrer sig
          undervejs.
        </p>
        <p>
          Din rådgiver kan hjælpe dig med at få overblik og se, om din pension
          passer til det liv, du gerne vil leve – både nu og i fremtiden.
        </p>
        <p>
          Her får du tre perspektiver, der måske får dig til at se lidt
          anderledes på din pension.
        </p>

        <Divider hidden />

        <Grid centered stackable columns={2}>
          <Grid.Row>
            <Grid.Column width={3}>
              <div
                className="fordele-ikon"
                style={{ backgroundImage: `url(${IkonStack})` }}
              ></div>
            </Grid.Column>
            <Grid.Column width={13}>
              <h4>Hvad giver 1 million kroner i opsparing?</h4>
              <p>
                1.000.000 kr. lyder af meget. Men et stort beløb på
                pensionskontoen kan være svært at omsætte til, hvad du faktisk
                har at leve for som pensionist. Det afhænger blandt andet af,
                hvordan og over hvor længe pengene skal udbetales.
              </p>
              <p>
                Hvis du har 1 million kroner på din pensionsopsparing med
                livsvarig udbetaling, kan den fx give dig omkring 5.200 kr. hver
                måned før skat, så længe du lever.
              </p>
              <p>
                Men beløbet siger ikke alt. Det er mindst lige så relevant at
                spørge, hvad pengene skal kunne finansiere, som hvor meget du
                har sparet op.
              </p>
              <p>
                Vil du fx rejse mere? Blive boende i dit hus? Have råd til at
                hjælpe børn og børnebørn? Eller bare have økonomisk luft til at
                gøre lidt mere af det, du har lyst til?
              </p>
              <p>
                Prøv at vende spørgsmålet om: Ikke kun{" "}
                <i>“Hvor meget får jeg i pension?”</i> – men{" "}
                <i>“Er det nok til det liv, jeg gerne vil leve?”</i>
              </p>
              <p>
                <i>Se forudsætninger for beregning nederst på siden. </i>
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3}>
              <div
                className="fordele-ikon"
                style={{ backgroundImage: `url(${IkonTag})` }}
              ></div>
            </Grid.Column>
            <Grid.Column width={13}>
              <h4>Hvad koster det at gå tidligere på pension?</h4>
              <p>
                Ekstra år uden arbejde kan være mere værd end et ekstra tal på
                pensionskontoen. Forestil dig, at du gerne vil stoppe med at
                arbejde som 68-årig i stedet for som 70-årig. Hvis du ønsker
                20.000 kr. om måneden før skat i de 2 år, skal du groft regnet
                have 480.000 kr. til at finansiere perioden.
              </p>
              <p>
                Det kan lyde af meget. Men beløbet skal ses i forhold til, hvor
                mange år du har til at spare op. Jo tidligere du begynder, jo
                mindre behøver du at lægge til side hver måned. Det skyldes
                både, at du har længere tid til at spare op, og at din opsparing
                har flere år til at vokse gennem renters rente.
              </p>
              <p>
                Der er også andre måder at skabe mere fleksibilitet i den sidste
                del af arbejdslivet. Det er derfor værd at tænke på
                pensionsopsparing som andet end penge til “engang, når du bliver
                gammel”. En opsparing kan også være frihed til selv at bestemme,
                hvornår arbejdslivet skal slutte – eller måske bare fylde lidt
                mindre.
              </p>
              <p>
                Og der er mange muligheder. Måske er ét år tidligere på pension
                det rigtige for dig. Måske vil du hellere gå ned i tid i de
                sidste år af arbejdslivet. Uanset hvad kan din rådgiver hjælpe
                dig med at undersøge mulighederne og regne på forskellige
                scenarier.
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3}>
              <div
                className="fordele-ikon"
                style={{ backgroundImage: `url(${IkonParaply})` }}
              ></div>
            </Grid.Column>
            <Grid.Column width={13}>
              <h4>Din pension skal også passe på dig undervejs</h4>
              <p>
                Du sparer op til fremtiden. Men hvad nu, hvis livet tager en
                uventet drejning inden da?
              </p>
              <p>
                Hvert år mister mange danskere evnen til at arbejde på grund af
                sygdom eller ulykke. Og selvom de færreste regner med, at det
                rammer dem, er det værd at vide, hvordan økonomien ser ud, hvis
                det gør.
              </p>
              <p>
                For hvad skal stadig være muligt, hvis du ikke længere kan
                arbejde som i dag? Skal der fortsat være råd til boligen, bilen
                og ferierne? Og hvordan skal din familie være stillet, hvis der
                sker dig noget?
              </p>
              <p>
                Dine forsikringer kan være med til at sikre, at en svær
                situation ikke også bliver en økonomisk krise.
              </p>
              <p>
                Brug to minutter på at tænke over, hvad der skal være muligt,
                hvis livet ændrer sig i morgen.
              </p>
              {/* <Button
                color="teal"
                as="a"
                href="https://vimeo.com/letpension/forberedelse?share=copy"
                target="blank"
              >
                Se video: Hvad skal være muligt, hvis livet ændrer sig?
              </Button> */}
              <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
                <iframe
                  src="https://player.vimeo.com/video/1173285281?h=d3b939ecd1&amp;title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                  }}
                  title="Hvad skal være muligt ... Letpension"
                ></iframe>
              </div>
              <script src="https://player.vimeo.com/api/player.js"></script>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Divider hidden />

        <h3>Brug 10 minutter på det liv, du skal leve i mange år</h3>
        <p>
          Du behøver ikke vide præcis, hvordan dit liv skal se ud om 10, 20
          eller 30 år. Men det er en god idé at vide, hvilke muligheder din
          pension giver dig – og om dine forsikringer passer til dit liv lige
          nu.
        </p>
        <p>På PensionsInfo kan du blandt andet se:</p>

        <ul>
          <li>hvad du kan forvente at få udbetalt, når du går på pension</li>
          <li>
            hvad der sker med din økonomi, hvis du går tidligere eller senere på
            pension
          </li>
          <li>hvilke forsikringer du har</li>
          <li>
            hvad du eller din familie kan få udbetalt ved sygdom, tab af
            arbejdsevne eller død.
          </li>
        </ul>
        <p>Så brug Pensionsdagen på at stille dig selv ét spørgsmål:</p>
        <p>Hvad skal min pension kunne for mig?</p>
        <p>
          Og tjek derefter – eventuelt sammen med din rådgiver – om du er på vej
          derhen.
        </p>

        <Button
          color="teal"
          as="a"
          href="https://pensionsinfo.dk/"
          target="blank"
        >
          Se din pension på Pensionsinfo
        </Button>
        <Divider hidden />
        <p>
          TIP! På PensionsInfo kan du danne en pensionsrapport, og logger du på
          via dit pengeinstitut, kan du sende rapporten direkte til din
          rådgiver.
        </p>
        <Divider hidden />
        <AutoAccordion activeIndex={-1}>
          <AutoAccordion.Item title="Hvad giver 1 million kroner i opsparing? – Sådan har vi regnet ">
            <p>
              Vi har regnet på, at en 67-årig har 1.000.000 kr. på en
              pensionsopsparing og begynder udbetaling. Valgt investering er PFA
              Plus Profil Middel. Der er medregnet maksimal periode for
              garanti/sikring af efterladte. Der er tale om en simpel beregning,
              som ikke tager højde for et eventuelt samspil med øvrige
              udbetalinger eller modregning i offentlige ydelser.
            </p>
          </AutoAccordion.Item>
        </AutoAccordion>
      </Segment>
    </Container>
  </div>
);

export default Pensionsdagen;
